<template lang="pug">
v-container
  v-row
    v-col.align-self-center
      v-subheader Подтверждение почты
      v-alert(:type="success ? 'success' : 'error'")
        span {{ success ? 'Почта успешно подтверждена' : 'Произошла ошибка!'}}
</template>
<script>
export default {
  data() {
    return {
      success: false,
    };
  },
  async created() {
    this.$loader.start();
    if (this.$route.query.verify) {
      await this.$api.auth.confirmVerify({ token: this.$route.query.verify }).then(() => {
        this.success = true;
        this.$user.syncUser();
      }).cath(() => this.$loader.stop());
    }
    this.$loader.stop();
  },
};
</script>
